import { Eye, EyeNo } from '@teachstonellc/component-library/dist/icons';

const DEFAULT_CLASSNAME =
  'flex items-center justify-center rounded-md p-3 text-ds-text-subtle border border-ds-border-control hover:bg-ds-surface-subtle focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ds-border-focus';

export interface VisibilityToggleProps {
  /** Whether the adjacent content is currently shown in plain text. */
  isShown: boolean;
  /** Accessible label used when the content is hidden (announces the action to reveal it). */
  showLabel: string;
  /** Accessible label used when the content is shown (announces the action to hide it). */
  hideLabel: string;
  /** Called when the button is activated to flip visibility. */
  onToggle: () => void;
  /** Override the default button styling. */
  className?: string;
}

/**
 * A button that toggles the visibility of adjacent masked content, such as a
 * password or other sensitive field. Renders as a real `<button>` so it's
 * focusable and keyboard-activatable without any extra wiring.
 */
function VisibilityToggle({
  isShown,
  showLabel,
  hideLabel,
  onToggle,
  className = DEFAULT_CLASSNAME
}: VisibilityToggleProps): JSX.Element {
  return (
    <button
      type="button"
      className={className}
      onClick={onToggle}
      aria-label={isShown ? hideLabel : showLabel}
      title={isShown ? hideLabel : showLabel}
    >
      {isShown ? <EyeNo size={16} /> : <Eye size={16} />}
    </button>
  );
}

export default VisibilityToggle;
